import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  Visibility,
  VisibilityOff,
  ArrowForward,
} from "@mui/icons-material";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import KeyIcon from "@mui/icons-material/Key";
import { toast } from "react-toastify";

import ErrorProps from "../../Component/Errorprops";
import { Link, useNavigate } from "react-router-dom";
import { commonCss } from "../../StyleConfig/CommonCss";
import { axiosPrivate } from "../../axios/axios";
import { api, companyInfo, roleInfo } from "../API/config";
import { useDispatch } from "react-redux";
import { loginDetail } from "../../Redux/authentication";
import { permitStatus } from "../../Redux/data";
import { meunuList } from "../../Component/layout/Info";
import AuthShell, { authFieldSx, authButtonSx } from "./AuthShell";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    emailId: "",
    password: "",
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    emailId: Yup.string().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const onSubmit = (values) => {
    const loginLink = api.account.login;
    console.log(values);
    axiosPrivate
      .post(`${loginLink}`, values)
      .then((res) => {
        console.log(res);
        const filteredMenu = meunuList
          .filter((item) => {
            if (item.userID === true) return item;
            return item.pspCompany
              ? item.userID.some((id) =>
                  String(res.data.data.roleIds).split(",").includes(id),
                ) ||
                  (item.pspCompany
                    ? res.data.data.companyId === companyInfo.ps
                    : false)
              : item.userID.some((id) =>
                  String(res.data.data.roleIds).split(",").includes(id),
                );
          })
          .map((menu) =>
            menu.title
              ? {
                  name: "Setting",
                  title: true,
                  userID: [roleInfo.admin],
                  childMenu: menu.childMenu.filter((child) =>
                    child.pspCompany
                      ? child.userID.some((id) =>
                          String(res.data.data.roleIds).split(",").includes(id),
                        ) && res.data.data.companyId === companyInfo.ps
                      : child.userID.some((id) =>
                          String(res.data.data.roleIds).split(",").includes(id),
                        ),
                  ),
                }
              : menu,
          );
        console.log(filteredMenu);
        dispatch(
          loginDetail({ loginInfo: res.data.data, menuList: filteredMenu }),
        );
        dispatch(permitStatus({ formStages: [], currentStage: 0 }));
        navigate(filteredMenu[0].link || "/dashboard");
        // if (String(res.data.data.roleIds).split(",").includes(roleInfo.admin)) {
        //   navigate("/dashboard");
        // } else if (
        //   String(res.data.data.roleIds).split(",").includes(roleInfo.oe) ||
        //   String(res.data.data.roleIds).split(",").includes(roleInfo.controller)
        // ) {
        //   navigate("/controllerroom");
        // } else {
        //   navigate(`/formlist/${btoa(roleName)}`);
        // }
      })
      .catch((e) => {
        console.log(e);
        toast.error(
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {e.response.data.errors !== null
              ? e.response.data.errors.map((d, i) => (
                  <Typography key={i}>
                    {i + 1 + ". " + d.errorMessage}
                  </Typography>
                ))
              : e.response.data.message}
          </Box>,
        );
      });
    // let email="ptw@gmail.com"
    // let password="123@PTW"
    // if(values.email===email&&values.password===password){
    //   navigate(`/formlist/${btoa(roleName)}`)
    // }else{
    //   toast.error("Invalid Email or Password")
    // }
  };
  return (
    <AuthShell
      title="Welcome Back"
      subtitle="Sign in to access your Permit to Work system"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.1rem",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
            <InputLabel>
              <Typography
                variant="body2"
                fontWeight={commonCss.labelFontWeight}
                color={commonCss.labelInputColor}
              >
                Email
              </Typography>
            </InputLabel>
            <Field
              as={TextField}
              type="email"
              fullWidth
              size="small"
              name="emailId"
              sx={authFieldSx}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AlternateEmailIcon sx={{ color: commonCss.blue }} />
                  </InputAdornment>
                ),
              }}
            />
            <ErrorMessage name="emailId">
              {(error) => <ErrorProps>{error}</ErrorProps>}
            </ErrorMessage>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <InputLabel>
                <Typography
                  variant="body2"
                  fontWeight={commonCss.labelFontWeight}
                  color={commonCss.labelInputColor}
                >
                  Password
                </Typography>
              </InputLabel>
              <Link to="/getemail" style={{ textDecoration: "none" }}>
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    color: commonCss.blue,
                  }}
                >
                  Forget Password?
                </Typography>
              </Link>
            </Box>
            <Field
              as={TextField}
              type={showPassword ? "text" : "password"}
              fullWidth
              size="small"
              name="password"
              sx={authFieldSx}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <KeyIcon sx={{ color: commonCss.blue }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <ErrorMessage name="password">
              {(error) => <ErrorProps>{error}</ErrorProps>}
            </ErrorMessage>
          </Box>

          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            fullWidth
            endIcon={!isLoading && <ArrowForward />}
            sx={authButtonSx(isLoading)}
          >
            {isLoading ? "Loading..." : "SIGN IN"}
          </Button>
        </Form>
      </Formik>
    </AuthShell>
  );
};

export default Login;




